// Centralized data for carriers and products

export const BROKER = {
  name: "Zaylan Welton",
  npn: "20763902",
  phone: "630-429-6685",
  phoneLink: "tel:+16304296685",
  email: "zaylanwelton@gmail.com",
  emailLink: "mailto:zaylanwelton@gmail.com",
  tagline: "Protecting Families. Securing Legacies.",
};

export const PRODUCTS = [
  {
    id: "whole-life",
    eyebrow: "01 — Permanent Protection",
    name: "Whole Life",
    short: "Lifetime coverage that builds wealth.",
    definition:
      "Permanent protection that lasts your entire life. It builds cash value over time that you can borrow against, ensuring long-term financial stability for your loved ones.",
    importance:
      "Crucial for final expenses, estate planning, and leaving a guaranteed financial legacy regardless of when you pass on.",
    bullets: [
      "Coverage that never expires",
      "Guaranteed cash value growth",
      "Fixed premiums for life",
      "Tax-advantaged transfer of wealth",
    ],
    icon: "shield",
  },
  {
    id: "term-life",
    eyebrow: "02 — Maximum Coverage",
    name: "Term Life",
    short: "The most coverage for the lowest cost.",
    definition:
      "Affordable coverage for a specific period — typically 10, 20, or 30 years. It offers the highest payout for the lowest cost during your most critical earning years.",
    importance:
      "Essential for replacing income, paying off a mortgage, and protecting young children while you build your wealth.",
    bullets: [
      "Highest payout per dollar",
      "Customizable term length",
      "Replace lost income",
      "Protect the mortgage & children",
    ],
    icon: "heart",
  },
  {
    id: "iul",
    eyebrow: "03 — Wealth Strategy",
    name: "Indexed Universal Life",
    short: "Protection that grows with the market.",
    definition:
      "Flexible permanent insurance that offers a death benefit while allowing cash value to grow tax-advantaged, linked to a market index without downside risk.",
    importance:
      "Perfect for individuals looking for dual-purpose protection and a supplemental, tax-favored retirement income strategy.",
    bullets: [
      "Market-linked growth — zero floor",
      "Tax-advantaged accumulation",
      "Flexible premiums & death benefit",
      "Supplemental retirement income",
    ],
    icon: "landmark",
  },
];

export const KIDS_PRODUCTS = [
  {
    id: "kids-whole-life",
    name: "Whole Life for Kids",
    summary:
      "Lock in lifelong coverage and a guaranteed insurable future for your child at the lowest premium they'll ever see.",
    bullets: [
      "Premiums never increase — locked in at today's age",
      "Guarantees future insurability regardless of health",
      "Cash value grows tax-deferred for college, a first home, or a wedding",
      "A meaningful, lasting gift only a parent or grandparent can give",
    ],
  },
  {
    id: "kids-iul",
    name: "IUL for Kids",
    summary:
      "Combine lifelong protection with market-linked cash growth — a head start on wealth that your child controls as an adult.",
    bullets: [
      "Tax-advantaged cash value tied to a market index, with a 0% floor",
      "Funds can be accessed tax-free for college, business, or retirement",
      "Decades of compounding — time is the biggest advantage",
      "A generational wealth-transfer tool, started in childhood",
    ],
  },
];

export const MORTGAGE_PROTECTION = {
  id: "mortgage-protection",
  name: "Mortgage Protection",
  tagline: "Keep your family in the home you built.",
  description:
    "A specialized life insurance policy designed to pay off your mortgage if you pass away unexpectedly — so your family never has to choose between grief and a foreclosure notice.",
  longDescription:
    "Mortgage Protection Insurance is a tailored term policy structured around the size of your home loan. If the unthinkable happens, the policy pays a lump-sum benefit that covers — or fully eliminates — the remaining mortgage. Your family keeps the house, the memories, and the stability you've worked so hard to build, without scrambling to make the next payment.",
  bullets: [
    "Coverage tailored to your mortgage balance & loan term",
    "Pays a tax-free lump sum directly to your beneficiary",
    "Optional living benefits — access funds for terminal illness, chronic illness, or disability",
    "Often costs less than a single monthly mortgage payment",
  ],
};


export const FACE_AMOUNTS = [
  "Not sure yet",
  "$0 – $100,000",
  "$100,000 – $250,000",
  "$250,000 – $550,000",
  "$550,000+",
];

export const INQUIRING_FOR = [
  "Myself",
  "Spouse",
  "Myself + Spouse",
  "Kids",
  "Parents",
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC"
];

export const CARRIERS = [
  { name: "Americo Financial Life and Annuity", url: "https://americo.com/", domain: "americo.com", region: "United States", bbb: "A+" },
  { name: "TransAmerica", url: "https://www.transamerica.com/", domain: "transamerica.com", region: "United States", bbb: "A+" },
  { name: "Mutual of Omaha", url: "https://www.mutualofomaha.com/", domain: "mutualofomaha.com", region: "United States", bbb: "A+" },
  { name: "Aflac", url: "https://www.aflac.com/", domain: "aflac.com", region: "United States", bbb: "A+" },
  { name: "Royal Neighbors", url: "https://www.royalneighbors.org/", domain: "royalneighbors.org", region: "United States", bbb: "A+" },
  { name: "American Amicable", url: "https://www.americanamicable.com/", domain: "americanamicable.com", region: "United States", bbb: "A+" },
  { name: "Ethos Life Insurance", url: "https://www.ethoslife.com/", domain: "ethoslife.com", region: "United States", bbb: "A+" },
  { name: "Liberty Bankers Life", url: "https://www.lbig.com/", domain: "lbig.com", region: "United States", bbb: "A+" },
  { name: "InstaBrain", url: "https://instabrain.com/", domain: "instabrain.com", region: "Digital Platform", bbb: "A" },
  { name: "Corebridge Financial", url: "https://www.corebridgefinancial.com/", domain: "corebridgefinancial.com", region: "United States", bbb: "A+" },
  { name: "Foresters Financial", url: "https://www.foresters.com/", domain: "foresters.com", region: "North America", bbb: "A+" },
  { name: "Aetna Life Insurance", url: "https://www.aetna.com/", domain: "aetna.com", region: "United States", bbb: "A+" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/27176613/pexels-photo-27176613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1600",
  necessity: "https://images.pexels.com/photos/7951671/pexels-photo-7951671.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  lifestyle: "https://images.pexels.com/photos/5638414/pexels-photo-5638414.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  contact: "https://images.pexels.com/photos/8524978/pexels-photo-8524978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  producer: "https://customer-assets.emergentagent.com/job_life-insurance-hub-10/artifacts/8nxzao6h_IMG_6714.JPG",
  family1: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=80",
  family2: "https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=1200&q=80",
};
